export default [
    { value: 8, label: 'General Surveys' },
    { value: 4, label: 'School Administrator Observations' },
    { value: 1, label: 'Teacher Observations' }
]